import { field, date, relation, writer, text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { CART_ITEMS } from '../schema';

export default class CartItems extends Model {
    static table = CART_ITEMS

    static associations = {
        stock: { type: "belongs_to", key: "stock_id" },
        cart: { type: 'belongs_to', key: 'cart_id' },
    }

    @text('product_name') product_name;
    @text('variant_name') variant_name;
    @text('supplier_id') supplier_id;
    @text('product_id') product_id;
    @text('variant_id') variant_id;
    @field('cost_price') cost_price;
    @field('totalStock') totalStock;
    @text('image_url') image_url;
    @field('quantity') quantity;
    @field('discount') discount;
    @field('price') price;
    @text('unit') unit;
    @field('tax') tax;

    @date('created_at') created_at;

    @relation('stock', 'stock_id') stock;
    @relation('cart', 'cart_id') cart;

    @writer async increment() {
        return await this.update(item => {
            item.quantity++
        });
    }

    @writer async updateAmount(price) {
        return await this.update(item => {
            item.price = price;
        });
    }

    @writer async updateQuantity(quantity) {
        await this.update(item => {
            item.quantity = quantity;
        });
    }

    @writer async decrement() {
        return await this.update(item => {
            item.quantity--
        });
    }

    @writer async markAsDeleted() {
        await super.markAsDeleted();
    }
}